import React from "react";
import HubspotForm from "./HubspotForm";

export default function MisimDemoForm() {
  return (
    <div className="bg-sidom-light dark:bg-sidom-blue min-h-screen flex flex-col relative overflow-hidden">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover z-0"
      >
        <source
          src="https://api.institucional.global.sidom.io/uploads/Dots_Background_15_1_0a34ee2d0d.mp4"
          type="video/mp4"
        />
      </video>
      <div className="relative z-10 flex flex-col min-h-screen">
        <main className="flex-1 flex flex-col items-center justify-center py-16 px-4 min-h-[70vh]">
          <h1 className="text-3xl mt-[100px] md:text-5xl font-extrabold text-sidom-orange mb-8 text-center">
            ¡Solicitá tu demo de MiSIM!
          </h1>
          <div className="w-full max-w-xl bg-white text-sidom-light dark:bg-sidom-blue rounded-2xl shadow-lg p-8 backdrop-blur-md bg-opacity-90 dark:bg-opacity-90">
            <HubspotForm />
          </div>
        </main>
      </div>
    </div>
  );
}
